/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function useMultigetFecher<T>(inp: {
  ids: () => string[] | None
  fetch(ids: string[]): Promise<T[]>
}) {
  const data = shallowReactive({ items: [] as T[] })
  let idsId: undefined | string

  function fetch(ids: string[] | None): unknown {
    if (!ids?.length) return (data.items = [])
    idsId = ids.join(':')
    inp.fetch(ids).then((i) => idsId === ids.join(':') && (data.items = i))
  }

  watch(() => inp.ids(), (ids) => fetch(ids), { immediate: true })

  return {
    items: toRef(() => data.items),
    refetch: () => fetch(inp.ids()),
  }
}
